import {observer} from 'mobx-react';
import React from 'react';
import {PromiseMessage} from '../../../../lib/components';
import {ClassroomDeleteStore} from './ClassroomDeleteStore';

@observer
export class ClassroomDeleteControls extends React.Component<{ store: ClassroomDeleteStore | null }> {
  render() {
    const store = this.props.store;
    if (store === null)
      return null;

    const isFailed = store.save?.isRejected === true;

    return (<>
      <PromiseMessage label="Deleting classroom" state={store.save} align="right"/>

      {
        isFailed &&
        <div className="row justify-content-end">
          <div className="col-auto">
            <button type="button" className="btn btn-primary"
                    onClick={store.parent.completeDelete}>
              Retry
            </button>
            <button type="button" className="btn btn-primary"
                    onClick={store.parent.cancel}>
              Cancel
            </button>
          </div>
        </div>
      }
    </>);
  }
}
